const MIN_BUBBLE_SIZE = 40;
const MAX_BUBBLE_SIZE = 160;

/**
 * Scaling function to deal with small and large bubble sizes - this is not inbuilt to echarts.
 * Uses linear interpolation to scale a value between min and max bubble sizes.
 */
export const calculateBubbleSize = (value: number, minValue: number, maxValue: number): number => {
  // If there's only one value or min equals max, return middle size
  if (minValue === maxValue) {
    return (MIN_BUBBLE_SIZE + MAX_BUBBLE_SIZE) / 2;
  }

  // Linear interpolation between MIN_BUBBLE_SIZE and MAX_BUBBLE_SIZE
  return (
    MIN_BUBBLE_SIZE +
    ((value - minValue) / (maxValue - minValue)) * (MAX_BUBBLE_SIZE - MIN_BUBBLE_SIZE)
  );
};
